import { useState } from "react";

export default function Copy({ text, targetId, label }) {
  const [state, setState] = useState("");
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setState("Copied");
    } catch (err) {
      const el = document.getElementById(targetId);
      if (el && window.getSelection) {
        const r = document.createRange();
        r.selectNodeContents(el);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(r);
        setState("Selected");
      }
    }
    setTimeout(() => setState(""), 1800);
  };
  return (
    <button type="button" className="copy" onClick={onClick} aria-label={`Copy ${label}`}>
      {state || "Copy"}
    </button>
  );
}
